window.feedbackSuccessShow = function feedbackSuccessShow() {
  $('.feedback-success').addClass('is-visible')
}
